import { MarketingChrome } from "../components/MarketingChrome";

const SECTIONS = [
  [
    "01",
    "Information we collect",
    "Application details (name, email, country), your voice sample and recordings, account details (including WhatsApp number and gender if provided) and payment information needed to send PayPal payouts.",
  ],
  [
    "02",
    "How we use it",
    "To review applications, manage contributor accounts, review submissions, issue payments, provide support and keep Inputry secure.",
  ],
  [
    "03",
    "Sharing",
    "We share information only with service providers who help us operate Inputry, such as payment processing, and where required by law.",
  ],
  [
    "04",
    "Your choices",
    "You can contact us to access, correct or delete your information, subject to legal and payment record requirements.",
  ],
  [
    "05",
    "Contact",
    "Questions about privacy? Reach us through the Contact page.",
  ],
];

export function Privacy() {
  return (
    <MarketingChrome back={{ to: "/", label: "Back to Inputry" }}>
      <article className="narrow-page" style={{ maxWidth: 760 }}>
        <div className="kicker"><i /> Legal</div>
        <h1 className="page-title-xl">Inputry Privacy Policy</h1>
        <div className="chip-row" style={{ marginBottom: 18 }}>
          <span className="mini-chip">Effective date: October 1, 2026</span>
          <span className="mini-chip">Last updated: October 1, 2026</span>
        </div>
        <div className="soft-card" style={{ marginBottom: 18 }}>
          <h3 style={{ marginTop: 0 }}>In short</h3>
          <p>
            We collect only what we need to review applications, manage contributor accounts and send
            payments. We don't sell your personal information.
          </p>
        </div>
        {SECTIONS.map(([num, title, copy]) => (
          <section key={num} className="legal-section">
            <h2>
              <span>{num}</span>
              {title}
            </h2>
            <p className="legal-copy">{copy}</p>
          </section>
        ))}
      </article>
    </MarketingChrome>
  );
}
